import { Slide } from '@/components/core/Slide';
import evaVideo from './eva-animated-loop.webm';
import qrLinkedIn from '/assets/images/qr-LinkedIn.png';

export const slide = () => {
  return (
    <Slide
      notes="Bedankt voor jullie deelname aan de AI proeverij workshop"
      visualizer="full"
      background={{
        video: evaVideo,
      }}
    >
      <div className="relative z-10 flex flex-col items-center justify-center h-full">
        <h1 className="text-8xl font-light text-white tracking-wider mb-8">Bedankt!</h1>
        <p className="text-3xl text-white/90 font-light">AI proeverij workshop</p>
      </div>
      <div className="fixed right-[14%] top-1/2 z-20" style={{ transform: 'translateY(-50%)' }}>
        <img src={qrLinkedIn} alt="LinkedIn QR Code" className="w-96 object-contain" />
      </div>
    </Slide>
  );
};
